import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbpButtonModule } from '@colibrium/abp-button';
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@colibrium/abp-button';

function AbpContentPopupComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "div", 2);
    ɵngcc0.ɵɵelementStart(3, "div", 3);
    ɵngcc0.ɵɵelementStart(4, "span", 4);
    ɵngcc0.ɵɵlistener("click", function AbpContentPopupComponent_ng_container_0_Template_span_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.onClose(); });
    ɵngcc0.ɵɵtext(5, "\u00D7");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "span");
    ɵngcc0.ɵɵprojection(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 5);
    ɵngcc0.ɵɵprojection(9, 1);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 6);
    ɵngcc0.ɵɵprojection(11, 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} }
const _c0 = [[["", "header", ""]], [["", "body", ""]], [["", "footer", ""]]];
const _c1 = ["[header]", "[body]", "[footer]"];
function AbpMessagePopupComponent_ng_container_0_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵelementStart(1, "span", 8);
    ɵngcc0.ɵɵlistener("click", function AbpMessagePopupComponent_ng_container_0_div_2_div_1_Template_span_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(3); return ctx_r5.onClose(); });
    ɵngcc0.ɵɵtext(2, "\u00D7");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "span", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("innerHtml", ctx_r2.model.headerContent, ɵngcc0.ɵɵsanitizeHtml);
} }
function AbpMessagePopupComponent_ng_container_0_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelement(1, "p", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHtml", ctx_r3.model.bodyContent, ɵngcc0.ɵɵsanitizeHtml);
} }
function AbpMessagePopupComponent_ng_container_0_div_2_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵelement(1, "span", 9);
    ɵngcc0.ɵɵelementStart(2, "div", 12);
    ɵngcc0.ɵɵelement(3, "abp-button", 13);
    ɵngcc0.ɵɵelement(4, "abp-button", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHtml", ctx_r4.model.footerContent, ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("field", ctx_r4.model.okButton);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("field", ctx_r4.model.cancelButton);
} }
function AbpMessagePopupComponent_ng_container_0_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵtemplate(1, AbpMessagePopupComponent_ng_container_0_div_2_div_1_Template, 4, 1, "div", 4);
    ɵngcc0.ɵɵtemplate(2, AbpMessagePopupComponent_ng_container_0_div_2_div_2_Template, 2, 1, "div", 5);
    ɵngcc0.ɵɵtemplate(3, AbpMessagePopupComponent_ng_container_0_div_2_div_3_Template, 5, 3, "div", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.model.headerContent);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.model.bodyContent);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.showFooter);
} }
function AbpMessagePopupComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵtemplate(2, AbpMessagePopupComponent_ng_container_0_div_2_Template, 4, 3, "div", 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.model);
} }
const _c2 = ".abp-popup-modal[_ngcontent-%COMP%]{display:block;position:fixed;z-index:1;left:0;top:0;width:100%;height:100%;overflow:auto;background-color:rgba(0,0,0,.4)}.abp-popup-content[_ngcontent-%COMP%]{background-color:#fefefe;margin:15% auto;padding:20px;width:50%;height:auto;overflow:auto}.abp-popup-content[_ngcontent-%COMP%]   .popup-header[_ngcontent-%COMP%]{align-items:flex-start;justify-content:space-between;padding:1rem;border-bottom:1px solid #dee2e6}.abp-popup-content[_ngcontent-%COMP%]   .popup-body[_ngcontent-%COMP%]{position:relative;flex:1 1 auto;padding:1rem}.abp-popup-content[_ngcontent-%COMP%]   .popup-footer[_ngcontent-%COMP%]{align-items:center;justify-content:flex-end;padding:1rem;border-top:1px solid #dee2e6;border-bottom-right-radius:.3rem;border-bottom-left-radius:.3rem}.close[_ngcontent-%COMP%]{color:#aaa;float:right!important;font-size:28px;font-weight:700}.close[_ngcontent-%COMP%]:focus, .close[_ngcontent-%COMP%]:hover{color:#000;text-decoration:none;cursor:pointer}";
export { AbpButtonFieldModel } from '@colibrium/abp-button';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion angular imports
//#region core imports
//#endregion core imports
//#region functional/model imports
//#endregion functional/model imports
class PopupBase {
    //#endregion input properties
    //#region model properties
    //#endregion model properties
    //#region constructor
    constructor() {
        //#region ViewChild
        //#endregion ViewChild
        //#region input properties
        this.showPopup = false;
        this.showPopupChange = new EventEmitter();
    }
    //#endregion constructor
    //#region public functions
    //#region life cycle event methods
    //#endregion life cycle event methods
    /**
     * on close click
     * @return {?}
     */
    onClose() {
        this.showPopup = false;
        this.showPopupChange.emit(false);
    }
}
PopupBase.ɵfac = function PopupBase_Factory(t) { return new (t || PopupBase)(); };
PopupBase.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: PopupBase, inputs: { showPopup: "showPopup" }, outputs: { showPopupChange: "showPopupChange" } });
PopupBase.propDecorators = {
    showPopup: [{ type: Input }],
    showPopupChange: [{ type: Output }]
};

if (false) {
    /** @type {?} */
    PopupBase.prototype.showPopup;
    /** @type {?} */
    PopupBase.prototype.showPopupChange;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion functional/model imports
class AbpContentPopupComponent extends PopupBase {
    //#region input properties
    //#endregion input properties
    //#region model properties
    //#endregion model properties
    //#region constructor
    constructor() {
        super();
    }
    //#endregion constructor
    //#region component events
    /**
     * @return {?}
     */
    ngOnInit() {
    }
}
AbpContentPopupComponent.ɵfac = function AbpContentPopupComponent_Factory(t) { return new (t || AbpContentPopupComponent)(); };
AbpContentPopupComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AbpContentPopupComponent, selectors: [["abp-content-popup"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c1, decls: 1, vars: 1, consts: [[4, "ngIf"], [1, "abp-popup-modal"], [1, "abp-popup-content"], [1, "popup-header"], [1, "close", 3, "click"], [1, "popup-body"], [1, "popup-footer"]], template: function AbpContentPopupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c0);
        ɵngcc0.ɵɵtemplate(0, AbpContentPopupComponent_ng_container_0_Template, 12, 0, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.showPopup);
    } }, directives: [ɵngcc1.NgIf], styles: [_c2] });
/** @nocollapse */
AbpContentPopupComponent.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AbpContentPopupComponent, [{
        type: Component,
        args: [{
                selector: 'abp-content-popup',
                template: "<ng-container *ngIf=\"showPopup\">\r\n  <div class=\"abp-popup-modal\">\r\n    <div class=\"abp-popup-content\">\r\n      <div class=\"popup-header\">\r\n        <span class=\"close\" (click)=\"onClose()\">&times;</span>\r\n        <span><ng-content select=\"[header]\"></ng-content></span>\r\n      </div>\r\n      <div class=\"popup-body\">\r\n        <ng-content select=\"[body]\"></ng-content>\r\n      </div>\r\n      <div class=\"popup-footer\">\r\n        <ng-content select=\"[footer]\"></ng-content>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-container>\r\n",
                styles: [".abp-popup-modal{display:block;position:fixed;z-index:1;left:0;top:0;width:100%;height:100%;overflow:auto;background-color:rgba(0,0,0,.4)}.abp-popup-content{background-color:#fefefe;margin:15% auto;padding:20px;width:50%;height:auto;overflow:auto}.abp-popup-content .popup-header{align-items:flex-start;justify-content:space-between;padding:1rem;border-bottom:1px solid #dee2e6}.abp-popup-content .popup-body{position:relative;flex:1 1 auto;padding:1rem}.abp-popup-content .popup-footer{align-items:center;justify-content:flex-end;padding:1rem;border-top:1px solid #dee2e6;border-bottom-right-radius:.3rem;border-bottom-left-radius:.3rem}.close{color:#aaa;float:right!important;font-size:28px;font-weight:700}.close:focus,.close:hover{color:#000;text-decoration:none;cursor:pointer}"]
            }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#region angular imports
//#endregion angular imports
//#region core imports
//#endregion core imports
//#region functional/model imports
//#endregion functional/model imports
class AbpMessagePopupModel {
}
if (false) {
    /** @type {?} */
    AbpMessagePopupModel.prototype.id;
    /** @type {?} */
    AbpMessagePopupModel.prototype.headerContent;
    /** @type {?} */
    AbpMessagePopupModel.prototype.bodyContent;
    /** @type {?} */
    AbpMessagePopupModel.prototype.footerContent;
    /** @type {?} */
    AbpMessagePopupModel.prototype.okButton;
    /** @type {?} */
    AbpMessagePopupModel.prototype.cancelButton;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion functional/model imports
class AbpMessagePopupComponent extends PopupBase {
    //#endregion model properties
    //#region constructor
    constructor() {
        super();
        //#endregion input properties
        //#region model properties
        this.showFooter = true;
    }
    //#endregion constructor
    //#region component events
    /**
     * @return {?}
     */
    ngOnInit() {
        this.setFooterDisplay();
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        this.setFooterDisplay();
    }
    //#endregion component events
    //#region service calls
    //#endregion service calls
    //#region public functions/events assoaciated with UI elements
    //#endregion public functions/events assoaciated with UI elements
    //#region private functions
    /**
     * sets footer display proeprty
     * @private
     * @return {?}
     */
    setFooterDisplay() {
        this.showFooter = false;
        if (this.model) {
            //if (this.model.footerContent || this.model.okButton || this.model.cancelButton) {
            //  this.showFooter = true;
            //}
        }
    }
}
AbpMessagePopupComponent.ɵfac = function AbpMessagePopupComponent_Factory(t) { return new (t || AbpMessagePopupComponent)(); };
AbpMessagePopupComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AbpMessagePopupComponent, selectors: [["abp-message-popup"]], inputs: { model: "model" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], [1, "abp-popup-modal"], ["class", "abp-popup-content", 4, "ngIf"], [1, "abp-popup-content"], ["class", "popup-header", 4, "ngIf"], ["class", "popup-body", 4, "ngIf"], ["class", "popup-footer", 4, "ngIf"], [1, "popup-header"], [1, "close", 3, "click"], [3, "innerHtml"], [1, "popup-body"], [1, "popup-footer"], [1, "float-right"], [3, "field"]], template: function AbpMessagePopupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, AbpMessagePopupComponent_ng_container_0_Template, 3, 1, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.showPopup);
    } }, directives: [ɵngcc1.NgIf, ɵngcc2.AbpButtonControlComponent], styles: [_c2] });
/** @nocollapse */
AbpMessagePopupComponent.ctorParameters = () => [];
AbpMessagePopupComponent.propDecorators = {
    model: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AbpMessagePopupComponent, [{
        type: Component,
        args: [{
                selector: 'abp-message-popup',
                template: "<ng-container *ngIf=\"showPopup\">\r\n  <div class=\"abp-popup-modal\">\r\n    <div class=\"abp-popup-content\" *ngIf=\"model\">\r\n      <div class=\"popup-header\" *ngIf=\"model.headerContent\">\r\n        <span class=\"close\" (click)=\"onClose()\">&times;</span>\r\n        <span [innerHtml]=\"model.headerContent\"></span>\r\n      </div>\r\n      <div class=\"popup-body\" *ngIf=\"model.bodyContent\">\r\n        <p [innerHtml]=\"model.bodyContent\"></p>\r\n      </div>\r\n      <div class=\"popup-footer\" *ngIf=\"showFooter\">\r\n        <span [innerHtml]=\"model.footerContent\"></span>\r\n        <div class=\"float-right\">\r\n          <abp-button [field]=\"model.okButton\"></abp-button>\r\n          <abp-button [field]=\"model.cancelButton\"></abp-button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-container>\r\n",
                styles: [".abp-popup-modal{display:block;position:fixed;z-index:1;left:0;top:0;width:100%;height:100%;overflow:auto;background-color:rgba(0,0,0,.4)}.abp-popup-content{background-color:#fefefe;margin:15% auto;padding:20px;width:50%;height:auto;overflow:auto}.abp-popup-content .popup-header{align-items:flex-start;justify-content:space-between;padding:1rem;border-bottom:1px solid #dee2e6}.abp-popup-content .popup-body{position:relative;flex:1 1 auto;padding:1rem}.abp-popup-content .popup-footer{align-items:center;justify-content:flex-end;padding:1rem;border-top:1px solid #dee2e6;border-bottom-right-radius:.3rem;border-bottom-left-radius:.3rem}.close{color:#aaa;float:right!important;font-size:28px;font-weight:700}.close:focus,.close:hover{color:#000;text-decoration:none;cursor:pointer}"]
            }]
    }], function () { return []; }, { model: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    AbpMessagePopupComponent.prototype.model;
    /** @type {?} */
    AbpMessagePopupComponent.prototype.showFooter;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion components
//#region directives
//#endregion directives
//#region pipes/filter
//#endregion pipes/filters
//#region services
//#endregion services
//#region handlers/providers
//#endregion handlers/providers
class AbpPopupModule {
}
AbpPopupModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AbpPopupModule });
AbpPopupModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AbpPopupModule_Factory(t) { return new (t || AbpPopupModule)(); }, imports: [[
            CommonModule,
            AbpButtonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AbpPopupModule, { declarations: function () { return [AbpContentPopupComponent, AbpMessagePopupComponent]; }, imports: function () { return [CommonModule,
        AbpButtonModule]; }, exports: function () { return [AbpContentPopupComponent, AbpMessagePopupComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AbpPopupModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    AbpButtonModule
                ],
                declarations: [
                    AbpContentPopupComponent,
                    AbpMessagePopupComponent
                ],
                exports: [
                    AbpContentPopupComponent,
                    AbpMessagePopupComponent
                ]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AbpContentPopupComponent, AbpMessagePopupComponent, AbpMessagePopupModel, AbpPopupModule, PopupBase as ɵa };

//# sourceMappingURL=colibrium-abp-popup.js.map